import { render, staticRenderFns } from "./BaseIndex.vue?vue&type=template&id=2570e5f4&scoped=true&"
import script from "./BaseIndex.vue?vue&type=script&lang=js&"
export * from "./BaseIndex.vue?vue&type=script&lang=js&"
import style0 from "./BaseIndex.vue?vue&type=style&index=0&id=2570e5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570e5f4",
  null
  
)

export default component.exports